export enum PaceTaskTabScreens {
  PaceTasksBrowse = 'Pace Tasks Browse',
  Project = 'Project',
  Engineering = 'Engineering',
  Leasing = 'Leasing',
  Permitting = 'Permitting',
  ProjectManagement = 'Project Management',
  Forecasting = 'Forecasting',
}
